// extracted by mini-css-extract-plugin
module.exports = {"clickable":"UniqueData_clickable__NzT3j"};